module.exports = __webpack_public_path__ + "static/shopify-2f10ea44a63a30775c319ab233210964.png";